
















































































import { Component, Vue, Prop } from 'vue-property-decorator'
import type { LibraryCategory, LibraryCategoryArticle } from '~/domains/library/Library.types'

import { htmlToText, truncate } from '~/utils/strings'

import Card from '~/components/UI/Card.vue'
import Btn from '~/components/UI/Btn.vue'
import ImgLazy from '~/components/ImgLazy.vue'
import BBAvatar from '~/components/BB/BBAvatar.vue'

const ARTICLES_DRAW_MAX = 4

@Component({
  components: {
    ImgLazy,
    Btn,
    Card,
    BBAvatar
  }
})
export default class LibrarySubcategories extends Vue {
  @Prop({
    type: Object,
    default: () => ({})
  })
  parentCategory: LibraryCategory

  @Prop({
    type: Array,
    default: () => ([])
  })
  categories: LibraryCategory[]

  @Prop({
    type: [Array, Object],
    default: () => ([])
  })
  articles: LibraryCategoryArticle[] | Record<string, LibraryCategoryArticle[]>

  formatCategoryDescription (description: string) {
    return truncate(htmlToText(description), 120)
  }

  categoryUrl (category: LibraryCategory) {
    return `/library/${this.parentCategory.chpuName}/${category.chpuName}`
  }

  getCategoryArticles (category: LibraryCategory): LibraryCategoryArticle[] {
    if (category.articles.length) {
      return category.articles
    }

    if (Array.isArray(this.articles)) {
      return this.articles.filter(article => article.categoryId === category.id)
    }

    let articles = this.articles[category.id]

    if (!articles && this.parentCategory) {
      const parentArticles = this.articles[this.parentCategory.id] || []
      articles = parentArticles.filter(article => article.categoryId === category.id)
    }

    return articles || []
  }

  getSlicedArticles (category: LibraryCategory) {
    return this.getCategoryArticles(category)
      .slice(0, ARTICLES_DRAW_MAX)
  }
}
